
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/aws-lambda",
      function () {
        return require("private-next-pages/destinations/aws-lambda.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/aws-lambda"])
      });
    }
  